import { initializeApp } from "firebase/app";
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
} from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const IS_EXTENSION = process.env.REACT_APP_EXTENSION === "true";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  ...(!IS_EXTENSION && {
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  }),
};

const app = initializeApp(firebaseConfig);

// Web: getAuth() — includes popup/redirect resolvers needed for signInWithPopup.
// Extension: initializeAuth with indexedDB — avoids iframe-based persistence
// that causes endless chrome-extension://invalid/ requests.
export const auth = IS_EXTENSION
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);

// Analytics — skip entirely in Chrome extensions (CSP blocks it)
if (!IS_EXTENSION) {
  isSupported().then((supported) => {
    if (supported) getAnalytics(app);
  });
}

export default app;
